<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="膜皮级别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'membraneLevel', validatorRules.membraneLevel]" placeholder="请输入膜皮级别"></a-input>
        </a-form-item>
        <a-form-item label="物料编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'materialCode', validatorRules.materialCode]" placeholder="请输入物料编码"></a-input>
        </a-form-item>
        <a-form-item label="花色" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'flowerColor', validatorRules.flowerColor]" placeholder="请输入花色"   ></a-input>
        </a-form-item>
        <a-form-item label="门型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'doorType', validatorRules.doorType]" placeholder="请输入门型"   ></a-input>
        </a-form-item>
        <a-form-item label="厨衣木归类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['classify', validatorRules.classify]" :trigger-change="true" dictCode="cym_type" placeholder="请选择厨衣木归类"/>
        </a-form-item>
        <a-form-item label="效果图" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload v-decorator="['picture', validatorRules.picture]" :trigger-change="true" :uploadData="uploadData1" number=1>
          </j-upload>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JUpload from './JUpload'

  export default {
    name: "MembraneModal",
    components: { 
      JUpload,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          membraneLevel: {rules: [
            {required: true, message: '请输入膜皮级别!'},
          ]},
          materialCode: {rules: [
            {required: true, message: '请输入物料编码!'},
          ]},
          flowerColor: {rules: [
            {required: true, message: '请输入花色!'},
          ]},
          doorType: {rules: [
            {required: true, message: '请输入门型!'},
          ]},
          classify: {rules: [
            // {required: true, message: '请输入厨衣木归类!'},
          ]}
        },
        url: {
          add: "/membrane/add",
          edit: "/membrane/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'membraneLevel','materialCode','flowerColor','doorType','classify','pictureName','picture'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'membraneLevel','materialCode','flowerColor','doorType','classify','pictureName','picture'))
      },
      uploadData1() {
        let filepathData = 'membrane';
        return { filePath: filepathData }
      },

      
    }
  }
</script>